// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { bitTorrent as _bitTorrent } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the bitTorrent chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 199
 * Chain Name: BitTorrent
 * Default Block Explorer: https://bttcscan.com
 * Default RPC URL: https://rpc.bittorrentchain.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { bitTorrent } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: bitTorrent,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const bitTorrent = createCommon({
	..._bitTorrent,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
